import { ArrowDownIcon, ArrowUpIcon } from 'assets/icons/';
import styled from 'styled-components';

export const StyledArrowDownIcon = styled(ArrowDownIcon)`
  > path {
    fill: ${({ theme }) => theme.components.accordion.arrowDown.color};
    stroke: ${({ theme }) => theme.components.accordion.arrowDown.color};
  }
`;

export const StyledArrowUpIcon = styled(ArrowUpIcon)`
  > path {
    fill: ${({ theme }) => theme.components.accordion.arrowUp.color};
    stroke: ${({ theme }) => theme.components.accordion.arrowUp.color};
  }
`;

export const StyledContentContainer = styled.div<{ $isinverted?: 'true' | 'false' }>`
  padding-top: 10px;
  border-top: ${({ theme, $isinverted }) =>
    $isinverted === 'true' ? 'unset' : theme.components.estimatedBillBottomSheet?.content.container.borderTop};
  border-bottom: ${({ theme, $isinverted }) =>
    $isinverted === 'true' ? theme.components.estimatedBillBottomSheet?.content.container.borderTop : 'unset'};
  ${({ $isinverted }) => $isinverted === 'true' && 'padding-bottom: 10px;'}
`;

export const StyledSpan = styled.span`
  gap: 10px;
`;
